import { render, staticRenderFns } from "./configuracoesImpresaoXLS.vue?vue&type=template&id=70a37020"
import script from "./configuracoesImpresaoXLS.ts?vue&type=script&lang=js&external"
export * from "./configuracoesImpresaoXLS.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a37020')) {
      api.createRecord('70a37020', component.options)
    } else {
      api.reload('70a37020', component.options)
    }
    module.hot.accept("./configuracoesImpresaoXLS.vue?vue&type=template&id=70a37020", function () {
      api.rerender('70a37020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/relatorio/configuracoesImpresaoXLS.vue"
export default component.exports